import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {
  Meta,
  Title,
  DomSanitizer,
  SafeResourceUrl,
  SafeUrl
} from '@angular/platform-browser';
import { ToastyService } from 'ng2-toasty';
import { DocumentService } from '../../../shared/services/documents.service';

@Component({
  selector: 'app-document-mecenat',
  templateUrl: './document_mecenat.component.html',
  styleUrls: ['./document_mecenat.component.css']
})
export class DocumentsMecenatComponent implements OnInit {
  // public jackpot: Jackpot;
  private url: SafeResourceUrl;
  private pdf: any;
  private download: boolean = false;
  public upload: boolean = true;
  public slideShare: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private documentService: DocumentService,
    private toastyService: ToastyService
  ) {}

  ngOnInit() {
    this.getUrl();
  }

  getUrl() {
    this.documentService.getUrl('mecenat').subscribe(data => {
      if (data) {
        this.mediaDownload(data);
      }
    });
  }

  uploadPdf(event) {
    if (event.target.files && event.target.files.length > 0) {
      this.upload = false;
      this.toastyService.wait({
        title: 'PDF Mécénat d’entreprise',
        msg: 'En cours de téléchargement',
        showClose: true,
        timeout: 30000,
        theme: 'bootstrap'
      });
      let pdf = event.target.files[0];
      const formData: FormData = new FormData();
      formData.append('document[url]', pdf, pdf.name);
      formData.append('document[description]', 'mecenat');
      this.documentService.upload(formData, '').subscribe(data => {
        this.getUrl();
        this.toastyService.clearAll();
        // this.toastyService.success({
        //   title: 'PDF Mécénat d’entreprise',
        //   msg: 'Mise à jour effectuée avec succès',
        //   showClose: true,
        //   timeout: 4000,
        //   theme: 'bootstrap'
        // });
      });
    }
  }

  updateSlideshare() {
    this.documentService
      .postSlideShareUrl('mecenat', this.slideShare)
      .subscribe(
        data => {
          if (data) {
            this.toastyService.success({
              title: 'URL Slideshare',
              msg: 'Mise à jour effectuée avec succès',
              showClose: true,
              timeout: 4000,
              theme: 'bootstrap'
            });
          }
        },
        err => console.log(err)
      );
  }

  mediaDownload(data) {
    this.download = false;
    if (data.slideshare_url) {
      this.slideShare = data.slideshare_url;
    }
    if (data.url) {
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
        data.url.url + '#view=Fit&scrollbar=1&toolbar=1&navpanes=1'
      );
      this.upload = true;
      this.download = true;
    }
  }
}
